module.exports = __webpack_public_path__ + "assets/img/icon6.fdf1559e.svg";